import { useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useDeploymentStoreHook } from "@/store/modules/deployment";
import { useUserStoreHook } from "@/store/modules/user";

/**
 * 登录重定向 hook
 * 用于在需要登录的场景下，统一处理跳转到登录页或渠道选择页
 * @param redirectUrl - 登录成功后跳转的 URL，默认使用 window.location.href
 */
export function useLoginRedirect() {
  const router = useRouter();
  const userStore = useUserStoreHook();
  const deploymentStore = useDeploymentStoreHook();
  const yChannelStore = useYChannelStoreHook();

  const redirectToLogin = (redirectUrl?: string) => {
    const targetUrl = redirectUrl || window.location.href;
    const { clients } = deploymentStore;
    const { configs } = yChannelStore;
    if (clients?.web?.registerEnabled && configs?.registerToSelectPage) {
      // 需要先选择渠道
      router.push({
        path: "/channel-select",
        query: { redirect: encodeURIComponent(targetUrl) }
      });
    } else {
      // 直接跳转登录页
      router.push({
        path: "/login",
        query: { redirect: encodeURIComponent(targetUrl) }
      });
    }
  };

  return {
    redirectToLogin,
    isLoggedIn: () => !!userStore.user?._id
  };
}
